export const hvm2c = require('./habitacion-vista-mar-2-camas.jpg');
export const estandar_2 = require('./estandar_2_camas.jpg');
export const estandar_1 = require('./habitacion-estandar-1-cama.jpg');
export const vista_mar_1 = require('./habitacion-vista-mar-1-cama.jpg');
export const junior_suite = require('./habitacion-junior-suite.jpg');
export const Logo = require('./logo.png');
export const LogopayPal = require('./logo-paypal.png');